"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _adminEdit = _interopRequireDefault(require("../adminEdit"));
var _staff = require("@/api/staff");
var _user = require("@/api/user");
var _userDetails = _interopRequireDefault(require("./userDetails.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  components: {
    adminEdit: _adminEdit.default,
    detailUser: _userDetails.default
  },
  data: function data() {
    return {
      roleArr: ['', '订单管理', '商品管理', '售后管理', '代客下单', '订单核销', '销量/用户统计', '工单管理'],
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      staffSearchData: {
        page: 1,
        limit: 10,
        keywords: '',
        status: ''
      },
      identityOption: [{
        label: '上货员',
        value: 0
      }, {
        label: '管理员',
        value: 1
      }],
      statusOption: [{
        label: '关闭',
        value: 0
      }, {
        label: '开启',
        value: 1
      }],
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0=添加，1=编辑
        data: {
          nickname: null,
          userAvatar: null
        }
      }
    };
  },
  created: function created() {
    this.getRoleList();
  },
  methods: {
    //关联用户详情
    toDetail: function toDetail(id) {
      this.$refs.userDetailFrom.getUserDetail(id);
      this.$refs.userDetailFrom.dialogUserDetail = true;
    },
    //表单重置
    handleReset: function handleReset() {
      this.staffSearchData.keywords = '';
      this.staffSearchData.status = '';
      this.getRoleList();
    },
    //表单搜索
    getSearch: function getSearch() {
      this.getRoleList();
    },
    //sie更改
    handleSizeChange: function handleSizeChange(val) {
      this.staffSearchData.limit = val;
      this.getRoleList();
    },
    //页数更改
    handleCurrentChange: function handleCurrentChange(val) {
      this.staffSearchData.page = val;
      this.getRoleList();
    },
    //更新
    updataStaff: function updataStaff(row) {
      var _this = this;
      (0, _staff.employeeUpdateRole)(row).then(function (res) {
        _this.$message.success(row.status == 1 ? '开启成功' : '关闭成功');
      });
    },
    //拼接管理权限
    roleText: function roleText(role) {
      var _this2 = this;
      var str = '';
      var arr = role.split(',');
      arr.forEach(function (ele, index) {
        str += _this2.roleArr[ele];
        index != arr.length - 1 && (str += '、');
      });
      return str;
    },
    //获取表格列表
    getRoleList: function getRoleList() {
      var _this3 = this;
      (0, _staff.employeeRoleList)(this.staffSearchData).then(function (res) {
        _this3.tableData.data = res.list;
        _this3.tableData.total = res.total;
      });
    },
    //添加员工
    addStaff: function addStaff() {
      this.editDialogConfig.isCreate = 0;
      this.editDialogConfig.visible = true;
    },
    //关闭弹出框
    hideEditDialog: function hideEditDialog(type, isCreate) {
      this.editDialogConfig.visible = false;
      this.getRoleList();
      isCreate == 0 && this.$message.success('添加成功');
      isCreate == 1 && this.$message.success('编辑成功');
    },
    //编辑
    handleEditMenu: function handleEditMenu(row) {
      this.editDialogConfig.isCreate = 1;
      this.editDialogConfig.data = row;
      this.editDialogConfig.visible = true;
    },
    //删除
    handleDelMenu: function handleDelMenu(row) {
      var _this4 = this;
      this.$modalSure('该员工删除后，将无法使用移动端-商家管理').then(function () {
        (0, _staff.employeeDelRole)(row.id).then(function (res) {
          _this4.$message.success('删除成功');
          _this4.getRoleList();
        });
      });
    }
  }
};